// extracted by mini-css-extract-plugin
export default {"table":"sales-section_table__vrvB1","labelCell":"sales-section_labelCell__GNpmw"};